import type { ZodSchema } from 'zod';

/**
 * 解析 + 校验 API 响应。
 *
 * - 开发模式：schema mismatch 直接 throw（让 bug 早暴露）
 * - 生产模式：warn + 返回 raw（避免线上崩溃）
 */
export function parseOrWarn<T>(schema: ZodSchema<T>, raw: unknown, where: string): T {
  const result = schema.safeParse(raw);
  if (result.success) return result.data;

  const issues = result.error.issues
    .map((i) => `  · ${i.path.join('.') || '<root>'}: ${i.message}`)
    .join('\n');
  const msg = `[zod-resolver] schema mismatch at ${where}:\n${issues}`;

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(msg, { raw });
    throw new Error(msg);
  }
  // eslint-disable-next-line no-console
  console.warn(msg, { raw });
  return raw as T;
}
